<template>
  <layout-main-inner title="抽样管理">
    <div
      v-if="permission.LVL2"
      slot="action">
      <el-button
        type="primary"
        @click="selectVendor">
        新增抽样
      </el-button>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <product-auto-select
          v-model="config.productId"
          :callback="()=> { handleCurrentChange(1) }" />
        <ent-auto-select
          v-model="config.vendorId"
          style="margin-left: 10px"
          :callback="()=> { handleCurrentChange(1) }" />
        <el-button
          type="primary"
          style="margin-left: 10px"
          @click="handleCurrentChange(1)"
        >查询</el-button>
        <el-button
          type="primary"
          @click="downloadtmp"
        >下载</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="抽样编号"
          width="80"
          prop="sampleNumber">
          <template slot-scope="{ row }">
            <el-link
              style="font-size:12px"
              :underline="false"
              type="primary"
              @click="toDetail(row)">{{ row.sampleNumber }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          label="样品名称"
          min-width="100"
          prop="productName"></el-table-column>
        <el-table-column
          label="产地"
          width="100"
          prop="originRegion"></el-table-column>
        <el-table-column
          label="样本数量"
          width="70"
          :formatter="(row)=> row.sampleQuantity + '份'"
          prop="sampleQuantity"></el-table-column>
        <el-table-column
          label="抽样费用"
          width="70"
          :formatter="(row)=> row.sampleCost + '元'"
          prop="sampleCost"></el-table-column>
        <!-- <el-table-column
          label="抽样地址"
          min-width="200"
          prop="vendorName">
          <template slot-scope="{ row }">
            {{ row.sampleProvinceName }}-{{ row.sampleCityName }}- {{ row.sampleAreaName }}-{{ row.sampleAddress }}
          </template>
        </el-table-column> -->
        <el-table-column
          label="企业信息"
          min-width="250"
          prop="vendorName">
          <template slot-scope="{ row }">
            <div>
              <span class="label">企业名称：</span>
              <span>{{ row.vendorName }}</span>
            </div>
            <div>
              <span class="label">联系人：</span>
              <span>{{ row.vendorPerson }}</span>
            </div>
            <div>
              <span class="label">联系电话：</span>
              <span>{{ row.vendorPhone }}</span>
            </div>
            <div>
              <span class="label">证照号码：</span>
              <span>{{ row.unifiedCreditCode }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!permission.LVL2"
          label="所属机构"
          prop="sgsName"
          min-width="140"
        ></el-table-column>
        <el-table-column
          label="快检报告"
          width="95"
          prop="reportImageFile">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.reportImageFile"
              style="width: 70px; height: 98.7px"
              :src="row.reportImageFile"
              :preview-src-list="[row.reportImageFile]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="抽样时间"
          width="135"
          prop="createdTime">
          <template slot-scope="{ row }">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="判定结果"
          width="100"
          prop="createdTime">
          <template slot-scope="{ row }">
            <template v-if="row.reportImageFile">
              <span
                v-if="row.unQualifiedInspectionDataItemCount === 0"
                style="color:#67c23a">合格</span>
              <span
                v-if="row.unQualifiedInspectionDataItemCount > 0"
                style="color:red">{{ row.unQualifiedInspectionDataItemCount }}项不合格</span>
            </template>

          </template>
        </el-table-column>
        <el-table-column
          v-if="permission.LVL2"
          label="操作"
          fixed="right"
          width="160">
          <template slot-scope="{ row }">
            <el-button
              type="info"
              @click="updateitem(row)">
              编辑
            </el-button>
            <el-dropdown>
              <el-button
                type="primary"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="deleteitem(row)">
                  删除
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="setitem(row)">
                  关联报告
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange">
      </el-pagination>
    </layout-card-wrap>
    <sample-select-modal
      ref="vendor"
      :autoClose="false"
      :callback="additem" />
    <sample-edit-modal
      ref="sample"
      :callback="()=> { getlist() }" />
    <report-select-modal
      ref="report"
      :callback="setReportitem" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EntAutoSelect from '../../components/ent-auto-select.vue'
import ProductAutoSelect from '../../components/product-auto-select.vue'
import ReportSelectModal from './busi/report-select-modal.vue'
import SampleEditModal from './busi/sample-edit-modal.vue'
import SampleSelectModal from './busi/sample-select-modal'

export default {
  name: 'InspectionReport',
  components: { EntAutoSelect, ProductAutoSelect, SampleSelectModal, SampleEditModal, ReportSelectModal },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      current: {},
      config: {
        pageNum: 1,
        pageSize: 10,
        productId: null,
        vendorId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    selectVendor() {
      this.$refs.vendor.fetch()
    },
    additem(vendor, product) {
      console.log(vendor, product)
      const {
        vendorId,
        vendorName,
        vendorPerson,
        vendorPhone,
        unifiedCreditCode,
        vendorAddress: sampleAddress,
        provinceCode,
        cityCode,
        areaCode
      } = vendor
      const {
        productId,
        productName
      } = product
      this.$refs.sample.init({
        vendorId,
        vendorName,
        vendorPerson,
        vendorPhone,
        unifiedCreditCode,
        sampleArea: [provinceCode, cityCode, areaCode],
        sampleAddress,
        productId,
        productName
      })
      // const { vendorId, vendorName, vendorPerson, vendorPhone, unifiedCreditCode, provinceCode, cityCode, areaCode } = row
      // this.$refs.edit.init({ vendorId, vendorName, vendorPerson, vendorPhone, unifiedCreditCode, provinceCode, cityCode, areaCode })
    },
    updateitem(row) {
      const {
        inspectionSampleId,
        vendorId,
        vendorName,
        vendorPerson,
        vendorPhone,
        unifiedCreditCode,
        productId,
        productName,
        sampleProvinceCode,
        sampleCityCode,
        sampleAreaCode,
        sampleAddress,
        originRegion, // 产地
        sampleQuantity,
        sampleCost,
        needSampling,
        createdTime,
        productionCount,
        productionTime,
        industrialPark,
        producer,
        producerPerson,
        producerAddress
      } = row
      this.$refs.sample.init({
        inspectionSampleId,
        vendorId,
        vendorName,
        vendorPerson,
        vendorPhone,
        unifiedCreditCode,
        productId,
        productName,
        sampleAddress,
        originRegion, // 产地
        sampleQuantity,
        sampleCost,
        needSampling,
        createdTime,
        productionCount,
        productionTime,
        industrialPark,
        producer,
        producerPerson,
        producerAddress,
        sampleArea: [sampleProvinceCode, sampleCityCode, sampleAreaCode]
      })
    },
    setitem(row) {
      this.current = row
      this.$refs.report.fetch(row)
    },
    setReportitem(current) {
      this.loading = true
      this.$store.dispatch(`account/updatesample`, {
        payload: {
          inspectionSampleId: this.current.inspectionSampleId,
          inspectionReportId: current.inspectionReportId
        },
        success: () => {
          this.$message.success('关联成功')
          this.loading = false
          this.getlist()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    toDetail(row) {
      this.$router.push('/inspection-sample-detail?inspectionSampleId=' + row.inspectionSampleId)
    },
    downloadtmp() {
      this.loading = true
      this.$store.dispatch('account/downloadsamples', {
        payload: this.config,
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getsamples', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteitem(row) {
      this.$confirm('此操作将永久删除该报告, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deleteinspectionreport', {
          payload: {
            inspectionReportId: row.inspectionReportId
          },
          success: () => {
            this.loading = false
            this.handleCurrentChange(1)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.label {
  color: #000;
}
</style>
